'use strict';
import Common from '../../Utils/Common';

/**
 * @classname BtnApplyCoupon
 * @classdesc クーポン適用
 */
export default class BtnApplyCoupon {
	/**
	 * @constructor
	 * @param {jQuery} $e - .btn--apply-coupon
	 * @param {instance} controller - controller instance
	 */
	constructor($e, controller) {
		console.log(`${this.constructor.name}.constructor`);
		this._$e = $e;
		this._controller = controller;
		this._initialShippingFee = $('.shipping_fee').text();
		$e.on('click', () => this.onClick());
		this._delete = false;
		controller.on('onApplyCouponComplete', () => this.setUsedCoupon());
		controller.on('wrongCouponCode', () => this.wrongCouponCode());
		controller.on('onReCalculateComplete', () => this.setNewAmount());
		this.onClick();
	};


	/**
	 * clickのコールバック
	 *
	 * @memberof BtnApplyCoupon
	 * @return undefined
	 */
	onClick() {
		console.log(`${this.constructor.name}.onClick`);
		const couponCode = this._$e.closest('.block--input-group').find('input').val();
		if(couponCode === ''){
			return;
		}else{
			this._controller.applyCoupon(couponCode);
		}
	};


	/**
	 * クーポン適用完了
	 *
	 * @memberof BtnApplyCoupon
	 * @return undefined
	 */
	setUsedCoupon() {
		if($('[name=coupon_type]:checked').val() !== '2') {
			console.log(`${this.constructor.name}.setUsedCoupon`);
			const coupon = this._controller._data;
			this._couponId = coupon.coupon_id;
			this._usedCoupon = `<input type="hidden" name="coupon_id" value="${this._couponId}"><div class="block__item block__item--used-coupon"><p class="text">適用中：<span>${coupon.coupon_name}</span></p><a class="anchor anchor--delete-coupon" data-coupon-id="${this._couponId}">&times;</a></div>`;
			this.reCalculate(this._couponId);
		}
	};


	/**
	 * クーポン適用完了
	 *
	 * @memberof BtnApplyCoupon
	 * @return undefined
	 */
	wrongCouponCode() {
		console.log(`${this.constructor.name}.wrongCouponCode`);
		$('#coupon_code').addClass('is-invalid');
		$('.block--used-coupon').html(`<div class="error-tip show"><div class="error-tip__inner"><p>${this._controller._message}</p></div></div>`);
	};


	/**
	 * クーポン削除
	 *
	 * @memberof BtnApplyCoupon
	 * @return undefined
	 */
	deleteCoupon() {
		console.log(`${this.constructor.name}.deleteCoupon`);
		$('.block--used-coupon').text('');
		$('.badge--selected-coupon').remove();
		$('#coupon_code').val('');
		this.reCalculate();
		$('.shipping_fee').text(this._initialShippingFee);
		this._delete = true;
	};


	/**
	 * 再計算
	 *
	 * @memberof BtnApplyCoupon
	 * @param {number} couponId - クーポンID
	 * @return undefined
	 */
	reCalculate(couponId = null) {
		console.log(`${this.constructor.name}.reCalculate`);
		this._controller.reCalculate(couponId);
	};


	/**
	 * 新価格設定
	 *
	 * @memberof BtnApplyCoupon
	 * @return undefined
	 */
	setNewAmount() {
		if($('[name=coupon_type]:checked').val() !== '2') {
			console.log(`${this.constructor.name}.setNewAmount`);
			const res = this._controller._data;
			console.log(res);
			if(res.is_coupon_applying === 1){
				$('.total_item_amount').text(`¥${Common.separatedByComma(res.total_item_amount)}`);
				$('.total_tax1').text(`¥${Common.separatedByComma(res.total_tax1)}`);
				$('.total_tax2').text(`¥${Common.separatedByComma(res.total_tax2)}`);
				$('.coupon_applying_amount').text(`-¥${Common.separatedByComma(res.coupon_applying_amount)}`);
				$('.total_amount').text(`¥${Common.separatedByComma(res.coupon_item_amount)}`);
				$('.shipping_fee').text(`¥${Common.separatedByComma(res.shipping_fee)}`);
				$('.total_billing_amount').text(`¥${Common.separatedByComma(res.total_billing_amount)}`);
				if(res.coupon_applying_amount === 0){
					$('.dl--cart-price.dl--coupon').hide();
				}else{
					$('.dl--cart-price.dl--coupon').show().css('display', 'flex');
				}

				this.setNotApplicableLabel(res.coupon_item_stock_ids);
				$('#coupon_code').removeClass('is-invalid').val('');
				$('.block--used-coupon').html(this._usedCoupon);
				$('.anchor--delete-coupon').on('click', () => this.deleteCoupon());
			}else{
				if(this._delete){
					// クーポン削除
					$('.badge--selected-coupon').remove();
					$('.block--used-coupon').html('');
					$('.dl--cart-price.dl--coupon').hide();
					$('.delete-selected-coupon').remove();
					$('#coupon_code').val('');
					$('.shipping_fee').text(this._initialShippingFee);
					this._delete = false;
				}else{
					// クーポン適用エラー
					Common.showErrorModal('このクーポンは条件に合っていないため<br>利用できません。');
					$('#coupon_code').val('');
				}
			}
		}
	};

	/**
	 * クーポン適用不可ラベルの設定
	 *
	 * @memberof BtnApplyCoupon
	 * @param {Array} couponItemStockIds - クーポン適用済商品在庫ID
	 * @return undefined
	 */
	setNotApplicableLabel(couponItemStockIds) {
		$('.badge--selected-coupon').remove();
		const label = '<span class="badge badge--cart-item badge--10 badge--selected-coupon">クーポン適用不可</span>';
		$('.list--cart-item .list__item input[name^=item_stock_id]').each((idx, e) => {
			const $e = $(e);
			const $imageBox = $(e).closest('.list__item').find('.image-box--cart-item');
			const existLabel = $imageBox.find('.badge--cart-item').length;
			const itemStockId = Number($(e).val());
			if (!couponItemStockIds.includes(itemStockId)) {
				if (!existLabel) {
					$imageBox.append(label);
				}
			}
		});
	}
};
